import { StyleSheet } from 'react-native';
import theme from '@/config/theme';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.grey,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  body: {
    flex: 1,
  },
  pager: {
    marginVertical: theme.spacings.xs,
  },
  activeCircle: {
    backgroundColor: theme.colors.darkestGrey,
  },
  isUpsideDown: {
    transform: [{ scaleY: -1 }, { scaleX: -1 }],
  },
});
